import { ArrowRight } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const CtaSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-28 bg-hero-bg" ref={ref}>
      <div className={`max-w-3xl mx-auto section-padding text-center ${visible ? "reveal-up" : "opacity-0"}`}>
        <h2 className="text-3xl md:text-4xl font-bold text-hero-foreground tracking-tight mb-5">
          Ready to Grow Your Practice?
        </h2>
        <p className="text-lg text-hero-foreground/70 mb-10 max-w-xl mx-auto leading-relaxed">
          No fluff, no contracts you can't understand. Just a straightforward conversation about what's working, what's not, and what we'd do differently.
        </p>
        <a
          href="https://www.xpresspromotion.com/contact"
          className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-lg text-base font-semibold hover:bg-accent/90 transition-all duration-200 active:scale-[0.97] shadow-lg shadow-accent/25"
        >
          Book a Free Strategy Call
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
};

export default CtaSection;
